import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AppStateService {
    private labId$ = new BehaviorSubject<string | null>(null);
    private showLabCases$ = new BehaviorSubject<boolean>(false);

    constructor() {
        const savedLabId = localStorage.getItem("lab_id");
        if (savedLabId) {
            this.labId$.next(savedLabId);
        }

        const savedShowLabCases = localStorage.getItem("show_lab_cases");
        if (savedShowLabCases && savedShowLabCases !== 'undefined' && savedShowLabCases !== 'null') {            
            this.showLabCases$.next(JSON.parse(savedShowLabCases));
        }
    }

    setLabId(id: string) {
        localStorage.setItem("lab_id", id);
        this.labId$.next(id);
    }

    setShowLabCases(flag: boolean) {
        localStorage.setItem("show_lab_cases", JSON.stringify(flag));
        this.showLabCases$.next(flag);
    }

    getLabId$(): Observable<string | null> {
        return this.labId$.asObservable();
    }

    getShowLabCases$(): Observable<boolean> {
        return this.showLabCases$.asObservable();
    }

    getReadyState$(): Observable<{ labId: string; showLabCases: boolean }> {
        return combineLatest([this.labId$, this.showLabCases$]).pipe(
            filter(([labId, show]) => !!labId && show === true),
            map(([labId, showLabCases]) => ({ labId: labId!, showLabCases }))
        );
    }
}
